__webpack_require__.p = "/newslaundry/assets/";